<template>
  <div
    class="select_area row"
    :class="variety"
  >
    <div class="col-12">
      <ul class="select_list row">
        <li
          v-for="(item, index) in list"
          :key="index"
          class="select_item col"
          :class="{
            active: item === activeValue,
            disabled: typeof listStatus[index] === 'boolean' && !listStatus[index],
            no_pointer: item === ''
          }"
          @click="returnActiveItem(item)"
        >
          <h3
            class="item_title"
            :class="{
              thin: thickness === 'thin'
            }"
          >
            {{ item }}
          </h3>
        </li>
      </ul>
    </div>
    <div class="col-12 d-block">
      <select
        id
        :value="activeValue"
        class="form-control select_list_mobile mt-4"
        @change="returnActiveItem($event.target.value)"
      >
        <option
          v-for="(item, index) in list"
          :key="index"
        >
          {{ item }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
import '~style/components/navigation.scss'
export default {
  name: 'Navigation',
  props: {
    list: {
      type: Array,
      required: true
    },
    listStatus: {
      type: Array,
      default: () => []
    },
    activeValue: {
      type: [String, Number],
      required: true
    },
    variety: {
      type: String,
      default: 'segmented',
      validator: value =>
        ['segmented', 'underline', 'portlet-header'].indexOf(value) !== -1
    },
    thickness: {
      type: String,
      default: 'thick'
    }
  },
  methods: {
    returnActiveItem (value) {
      this.$emit('active:updated', value)
    }
  }
}
</script>
